import { render, staticRenderFns } from "./CompareContent.vue?vue&type=template&id=efc6664c&"
import script from "./CompareContent.vue?vue&type=script&lang=js&"
export * from "./CompareContent.vue?vue&type=script&lang=js&"
import style0 from "./CompareContent.vue?vue&type=style&index=0&id=efc6664c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports